import { useHistory } from 'react-router-dom';

import { errorHandler } from '@/lib/ErrorHandler';
import { getClient } from '@/lib/restClient';
import { AuthService, PasswordResetRequestForm } from '@/services/Auth';

export const usePasswordResetRequest = (): ((
  email: string
) => Promise<void>) => {
  const authService = new AuthService(getClient());
  const history = useHistory();

  const passwordResetRequest = async (email: string) => {
    const body: PasswordResetRequestForm = { email };
    return await authService
      .passwordResetRequest(body)
      .then(() => history.push('/reset-password/requested'))
      .catch((error: Error) => errorHandler({ error }));
  };

  return passwordResetRequest;
};
